<template>
  <NavbarOne />
  <PageBanner
    pageTitle="قائمة القنوات"
    subTitle="تصفح مجموعة واسعة من القنوات العربية والعالمية، الرياضية، الترفيهية، الإخبارية وقنوات الأطفال ضمن اشتراك IPTV واحد بجودة عالية وثبات ممتاز."
    :pageBannerImage="pageBannerImg"
  />
  <TheListOfChannels />
  <EnjoySports />
  <SubscribeContent />
  <MainFooter class="bg-black" />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useHead } from "@unhead/vue";
import NavbarOne from "@/components/Layouts/NavbarOne.vue";
import PageBanner from "@/components/Common/PageBanner.vue";
import TheListOfChannels from "@/components/ChannelList/TheListOfChannels.vue";
import EnjoySports from "@/components/ChannelList/EnjoySports.vue";
import SubscribeContent from "@/components/Common/SubscribeContent.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "ChannelListPage",
  components: {
    NavbarOne,
    PageBanner,
    TheListOfChannels,
    EnjoySports,
    SubscribeContent,
    MainFooter,
    CopyRight,
  },
  setup() {
    useHead({
      title: "قائمة قنوات IPTV | قنوات عربية ورياضية بجودة HD و4K",
      meta: [
        {
          name: "description",
          content:
            "اكتشف قائمة قنوات IPTV التي تضم القنوات العربية والعالمية، القنوات الرياضية، الإخبارية، الترفيهية وقنوات الأطفال بجودة HD و4K مع بث مستقر على جميع الأجهزة.",
        },
        {
          name: "keywords",
          content:
            "قائمة قنوات IPTV, قنوات عربية, قنوات رياضية, قنوات أطفال, قنوات إخبارية, قنوات ترفيهية, IPTV HD, IPTV 4K",
        },
        {
          property: "og:title",
          content: "قائمة قنوات IPTV | قنوات عربية ورياضية",
        },
        {
          property: "og:description",
          content:
            "تصفح قائمة واسعة من القنوات العربية والعالمية والرياضية والترفيهية ضمن اشتراك IPTV واحد.",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://karamtv4k.com/channel-list",
        },
      ],
    });

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const pageBannerImg = require("@/assets/images/page-banner-1.jpg");

    return {
      pageBannerImg,
    };
  },
});
</script>